export const INITIAL_WARMUP_DATA = 'initialData';
